import React from "react";

const Button = ({
    icon,
    title,
    subtitle,
    isActive,
    activeRightBorderColor,
    type,
    handleClick,
}) => {
    const rightBorderClass = isActive ? `border-r-4 ${activeRightBorderColor}` : "";

    return (
        <button
            className={`w-full flex justify-start items-center gap-3 p-4 rounded-lg border border-ec-table-stock"
            } ${rightBorderClass} cursor-pointer hover:shadow-[0px_4px_20px_0px_#0000000F] transition-all duration-200`}
            onClick={handleClick}
        >
            <div>
                <img
                    src={icon}
                    alt="icon"
                    className="w-10 h-10 pointer-events-none"
                />
            </div>

            <div>
                <p className="font-inter font-medium text-xl leading-[26px] text-ec-body text-left">
                    {type === "amount"
                        ? `${EASYCOMMERCE.currency_symbol}${Number(title).toFixed(2)}`
                        : title}
                </p>
                <p className="font-inter font-normal text-sm leading-4 text-ec-body text-left">
                    {subtitle}
                </p>
            </div>
        </button>
    );
};

export default Button;
